module.exports = __webpack_public_path__ + "static/img/B1-.22da2b1b.png";